import React, { useEffect, useRef, useState } from "react"
import {  CheckboxGroupInput, ImageField,  ImageInput, TextInput, useRecordContext } from "react-admin"
import {  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Modal, Slider, Tab, Tabs, TextField, } from "@mui/material";
import ReactCrop, { centerCrop, Crop, makeAspectCrop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import {  ImageSize } from "./GalleryItemModal";
import CropIcon from '@mui/icons-material/Crop';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import FlipIcon from '@mui/icons-material/Flip';
import Cropper from 'react-easy-crop';


export const AdditionalImageEditModal = (props) =>{
    const open = props.open;
    const setOpen = props.setOpen;
    const onClose = props.onClose;
    const originalImage = props.image;
    const imageSize:ImageSize = props.imageSize;
    const [transformations, setTransformations] = useState(
        {
            rotation:0, 
            flip:false, 
            zoom:1, 
            crop:{x:25,y:25},
            aspectRation:[1,1],
            croppedAreaPixels:null,
            resolution:imageSize?.resolution
        })
    const [canCrop, setCanCrop] = useState(false);

    useEffect(() => {
        resetTransformations();
        setTransformations((prevState)=>({
            ...prevState,
            resolution: imageSize.resolution,
            aspectRation:imageSize.resolution,
        }))
        if(imageSize?.option === "custom"){
            setCanCrop(true);
            setTransformations((prevState)=>({
                ...prevState,
                aspectRation:[1,1],
            }))
        }
        else{
            setCanCrop(false);
            if(imageSize?.option === "base_image")
                setTransformations((prevState)=>({
                    ...prevState,
                    aspectRation: [16,9]
                }))
        }
    }, [,imageSize])


    function resetTransformations(){
        setTransformations(
            {
                rotation:0, 
                flip:false, 
                zoom:1, 
                crop:{x:25,y:25},
                aspectRation:[1,1],
                croppedAreaPixels:null,
                resolution:imageSize?.resolution
            })
    }

    function flip(){
        setTransformations((prevState)=>({
            ...prevState,
            flip: !prevState.flip,
        }))
    }

    function rotate(){
        setTransformations((prevState)=>({
            ...prevState,
            rotation: (prevState.rotation+90 === 360)?0:prevState.rotation+90
        }))
    }

    function setZoom(e){
        setTransformations((prevState)=>({
            ...prevState,
            zoom: e
        }))
    }
    
    function setRotation(e){
        setTransformations((prevState)=>({
            ...prevState,
            rotation: e
        }))
    }

    function setCrop(e){
        setTransformations((prevState)=>({
            ...prevState,
            crop: e
        }))
    }

    function getRadianAngle(degreeValue) {
        return (degreeValue * Math.PI) / 180;
      }
      
    function rotateSize(width, height, rotation) {
        const rotRad = getRadianAngle(rotation);
      
        return {
          width:
            Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
          height:
            Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
        };
      }

   

    function saveImage(){
        var img = new Image();
        img.src = originalImage.previewImage;
        img.onload = () => {
            var canvas = document.createElement("canvas");
          
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            let x=0
            let y=0
            
            ctx.drawImage(img, x, y, img.width, img.height, - 
                x - img.width, y, img.width, img.height);

            const rotRad = getRadianAngle(transformations.rotation);

            const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
                img.width,
                img.height,
                transformations.rotation
            );

            canvas.width = bBoxWidth;
            canvas.height = bBoxHeight;

            let horizontalFlip = transformations.flip && (transformations.rotation===0||transformations.rotation===180)
            let verticalFlip = transformations.flip && (transformations.rotation===90||transformations.rotation===270)

            ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
            ctx.scale(horizontalFlip ? -1 : 1, verticalFlip? -1:1);
            ctx.rotate(rotRad);
            ctx.translate(-img.width / 2, -img.height / 2);

            ctx.drawImage(img, 0, 0);

            const data = ctx.getImageData(
                transformations.croppedAreaPixels.x,
                transformations.croppedAreaPixels.y,
                transformations.croppedAreaPixels.width,
                transformations.croppedAreaPixels.height,
            );
            

            canvas.width = transformations.croppedAreaPixels.width;
            canvas.height = transformations.croppedAreaPixels.height;

            ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height,
                0, 0, transformations.resolution[0], transformations.resolution[1]);
            
            ctx.putImageData(data, 0, 0);
            let newImage = ""
            
            canvas.toBlob(function(blob){
                newImage = URL.createObjectURL(blob);
                onClose(newImage);
              },'image/png');
        };
    }

    const cropComplete = (croppedArea, croppedAreaPixels) => {
        setTransformations((prevState)=>({
            ...prevState,
            croppedAreaPixels: croppedAreaPixels
        }))
      };

    const setResolution = (event, index)=>{

        if(isNaN(event.target.value) || !event.target.value)
            return;
            
        let value:number = parseInt(event.target.value)

        let res = transformations.resolution;
        res[index] = value;

        setTransformations((prevState)=>({
            ...prevState,
            resolution: res
        }))
    };

    const resizeAspectRatio = ()=>{
        setTransformations((prevState)=>({
            ...prevState,
            aspectRation: [prevState.resolution[0],prevState.resolution[1]]
        }))
    }

    const transformProps = (" translate("+transformations.crop.x+"px, "+transformations.crop.y+"px)"+((transformations.rotation===90||transformations.rotation===270)?"scaleY(-1)":"scaleX(-1)")+" rotate("+transformations.rotation+"deg)"+" scale("+transformations.zoom+")")

    return (
        <Dialog
            open={open}
            onClose={()=>setOpen(false)}
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>Edit Image</DialogTitle>
            <DialogContent dividers  
                sx={{
                    background: '#333',
                    position: 'relative',
                    height: 500,
                    width: 'auto',
                    minWidth: { sm: 400 },
                }}>
                <Cropper
                    image={originalImage.previewImage}
                    transform={transformations.flip && transformProps}
                    crop={transformations.crop}
                    zoom={transformations.zoom}
                    rotation={transformations.rotation}
                    aspect={transformations.aspectRation && transformations.aspectRation[0]/transformations.aspectRation[1]}
                    onZoomChange={setZoom}
                    onRotationChange={setRotation}
                    onCropChange={setCrop}
                    onCropComplete={cropComplete}
                    />
            </DialogContent>
            <DialogActions sx={{ flexDirection: 'column', mx: 3, my: 2 }}>
                <Box sx={{ width: '100%', mb:1, display:'flex', justifyContent:'center' }}>
                    <Box sx={{borderRight:'1px solid #E6E8F0', padding:'8px 16px', display:'inline-block', gap:2}}>
                        <TextField label="Width" variant="outlined" value={transformations.resolution?transformations.resolution[0]:""} onChange={(e)=>setResolution(e, 0)} type="number" disabled={!canCrop} sx={{width:'120px'}}/>
                        <TextField label="Height" variant="outlined" value={transformations.resolution?transformations.resolution[1]:""} onChange={(e)=>setResolution(e, 1)} type="number" disabled={!canCrop} sx={{width:'120px', ml:1}}/>
                        <Button variant="contained" disabled={!canCrop} startIcon={<CropIcon />} sx={{mt:1, ml:2}} onClick={resizeAspectRatio}>Resize</Button>
                    </Box>
                    <Box sx={{borderRight:'1px solid #E6E8F0', padding:'8px 16px', display:'inline-block', gap:2}}>
                        <Button variant="contained" startIcon={<RotateRightIcon />} sx={{mt:1}} onClick={rotate}>Rotate</Button>
                        <Button variant="contained" startIcon={<FlipIcon />} sx={{mt:1, ml:1}} onClick={flip}>Flip</Button>
                    </Box>
                    <Box sx={{padding:'8px 16px', display:'inline-block', gap:2, minWidth:"200px"}}>
                        <Box sx={{mx:1}}>
                            <label>
                            Zoom
                            <Slider
                                value={transformations.zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="zoom"
                                onChange={(e, zoom) => setZoom(zoom)}
                                className="range"
                            />
                            </label>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{display:'flex', gap: 2, flexWrap: 'wrap', my:1}}>
                    <Button variant="contained" startIcon={<CropIcon/>} onClick={saveImage} disabled={transformations.resolution && (transformations.resolution[0]<1 || transformations.resolution[1]<1)}>
                        Crop
                    </Button>
                    <Button variant="outlined" onClick={()=>setOpen(false)}>
                        Cancel
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}
